import React from "react";
import { Icon } from "@livingmap/hippo";

import { CheckAndRadioInterface } from "../FormControl";
import styles from "./Radio.module.scss";

type Props = Omit<CheckAndRadioInterface, "type">;

const Radio: React.FC<Props> = ({
  displayCheckboxBubble,
  dataQA,
  ...props
}) => {
  return (
    <div data-qa={dataQA} className={styles.container}>
      <input
        type="radio"
        className={styles.input}
        {...props}
        value={props.value || ""}
      />
      <label htmlFor={props.id} className={styles.label}>
        <span className={styles.iconWrapper}>
          <Icon
            dataQA="radio-button-unchecked-icon"
            name="radio_button_unchecked"
            size={24}
            className={styles.unchecked}
          />
          <Icon
            dataQA="radio-button-checked-icon"
            name="radio_button_checked"
            size={24}
            className={styles.checked}
          />
        </span>
        {props.label && <span className={styles.labelText}>{props.label}</span>}
      </label>
    </div>
  );
};

export default Radio;
